export default "__VITE_ASSET__DJGopgdu__"